<app-breadcrumbs></app-breadcrumbs>
<div class="date-pickers">
    <button mat-raised-button (click)="getFortinetMetrics(offlineEvents, last30DaysTimeInMilliseconds, currentTimeInMilliseconds)" color="primary" id="store-number-search-button">
        <mat-icon>search</mat-icon>
    </button>
    <mat-form-field>
        <input matInput [matDatepicker]="startDate" placeholder="Choose start date" (onChange)="dateChanged($event)">
        <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
        <mat-datepicker #startDate></mat-datepicker>
    </mat-form-field>  
       to  
    <mat-form-field>
        <input matInput [matDatepicker]="endDate" placeholder="Choose end date">
        <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
        <mat-datepicker #endDate></mat-datepicker>
    </mat-form-field>
</div>

  
<div class="main-card-wrapper">
    <div class="card-section-1">
        <div class="subsection-card-container">
            <div class="nav-cards-container">
                <mat-card>
                    <mat-card-header>
                        <mat-card-title>  Chainwide Router Availability: last 30 days  </mat-card-title>
                    </mat-card-header>
                    <mat-divider></mat-divider>
                    <h6>{{last30DaysDate}}  to  {{currentDate}}</h6>
                    <mat-divider></mat-divider>
                    <div [cfaLoading]="isLoading">
                        <mat-card-content>
                            <div class="donut-chart">
                                <!-- <ngx-charts-pie-grid></ngx-charts-pie-grid> -->
                            </div>
                            <h3>{{availabilityPercent}}%</h3>
                            availability
                        </mat-card-content>
                    </div>
                </mat-card>
            </div>
        </div>
    </div>
    <div class="card-section-2">
        <div class="subsection-card-container">
            <div class="nav-cards-container">
                <mat-card>
                    <mat-card-header>
                        <mat-card-title>Offline Events</mat-card-title>
                    </mat-card-header>
                    <mat-divider></mat-divider>
                    <mat-card-content>
                        <h3>{{numOfflineEvents}}</h3>
                        events
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
        <div class="subsection-card-container">
            <div class="nav-cards-container">
                <mat-card>
                    <mat-card-header>
                        <mat-card-title>Average Offline Duration</mat-card-title>
                    </mat-card-header>
                    <mat-divider></mat-divider>
                    <mat-card-content>
                        <h3>{{avgOfflineDuration}}</h3>
                        hours
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
        <div class="subsection-card-container">
            <div class="nav-cards-container">
                <mat-card>
                    <mat-card-header>
                        <mat-card-title>Total Devices</mat-card-title>
                    </mat-card-header>
                    <mat-divider></mat-divider>
                    <mat-card-content>
                        <h3>{{numDevices}}</h3>
                        devices
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </div>
</div>

<!-- <div class="store-number-toolbar">
    <div [cfaLoading]="isLoading">
        <button mat-raised-button (click)="getLanHealth()" color="primary" id="store-number-search-button">
            <mat-icon>search</mat-icon>
        </button>
        <mat-form-field id="store-number-search-field" appearance="outline">
            <mat-label>Store Number</mat-label>
            <input matInput maxlength="5" minlength="5" (keydown.enter)="getLanHealth()" [(ngModel)]="storeNumber" autofocus/>
        </mat-form-field>
    </div>
</div> -->

<!-- <div class="metric-cards-wrapper">
    <div class="availability-card-wrapper">
    
        <mat-card>
            <mat-card-header>
                <mat-card-title>Chainwide Router Availability: last 30 days</mat-card-title>
            </mat-card-header>
            <mat-divider></mat-divider>
            <h6>{{last30DaysDate}} to  {{currentDate}}</h6>
            <mat-divider></mat-divider>
            <div [cfaLoading]="isLoading">
                <mat-card-content>
                    <h3>{{availabilityPercent}}%</h3>
                    <div class="donut-chart">
                        <ngx-charts-pie-grid></ngx-charts-pie-grid>
                    </div>
                </mat-card-content>
            </div>
        </mat-card>
    </div>
    
    <div class="data-cards-wrapper">
        <div class="devices-card">
            <mat-card>
                <mat-card-header>
                    <mat-card-title>Total Devices</mat-card-title>
                </mat-card-header>
                <mat-divider></mat-divider>
                <mat-card-content>
                    <h3>{{numDevices}}</h3>
                    devices
                </mat-card-content>
            </mat-card>
        </div>
        <div class="events-card">
            <mat-card>
                <mat-card-header>
                    <mat-card-title>Offline Events</mat-card-title>
                </mat-card-header>
                <mat-divider></mat-divider>
                <mat-card-content>
                    <h3>{{numOfflineEvents}}</h3>
                    events
                </mat-card-content>
            </mat-card>
        </div>
        <div class="duration-card">
            <mat-card>
                <mat-card-header>
                    <mat-card-title>Average Offline Duration</mat-card-title>
                </mat-card-header>
                <mat-divider></mat-divider>
                <mat-card-content>
                    <h3>{{avgOfflineDuration}}</h3>
                    hours
                </mat-card-content>
            </mat-card>
        </div>      
    </div>    
</div> -->